import React from 'react';

import './engiven.css';
import { Trans, useTranslation } from 'react-i18next';

import image from '../../../public/engiven.png';
import { PaymentLabel } from '../../@types/types';
import { GivingType } from '../../shared/constants';
import Link from '../link/Link';

export type EngivenProps = {
	paymentLabel: PaymentLabel;
	type: GivingType;
};

export function EngivenGiving({ paymentLabel, type }: EngivenProps) {
	const { t: translate } = useTranslation();
	const givingText = type === GivingType.CRYPTOCURRENCY ? translate('engiven.crypto') : translate('engiven.stock');

	return (
		<div className="engiven">
			<img alt="Engiven Logo" className="engiven-logo" src={image} width="208" />
			<span className="engiven-text">
				{translate('engiven.lineA', {
					label: paymentLabel.VerbLowerCase,
					type: givingText,
				})}
			</span>
			<span className="engiven-text">
				{translate('engiven.lineB', {
					label: paymentLabel.NounLowerCase,
				})}
			</span>
			<span className="engiven-text">
				{translate('engiven.lineC', {
					label: paymentLabel.NounPluralLowerCase,
				})}
			</span>
			<Trans
				className="engiven-text"
				components={[
					<Link
						className="engiven-link"
						href="https://help.pushpay.com/s/knowledge/How-to-Give-using-Cryptocurrency"
						rel="noopener noreferrer"
						target="_blank"
					>
						{translate('engiven.clickHere')}
					</Link>,
				]}
				i18nKey="engiven.lineD"
				values={{
					type: givingText,
					label: paymentLabel.ActionLowerCase,
				}}
			/>
			<Link
				className="engiven-terms-link"
				href="https://www.engiven.com/terms-of-service"
				rel="noopener noreferrer"
				target="_blank"
			>
				{translate('engiven.terms')}
			</Link>
		</div>
	);
}
